
/* Enum values for Redux state 'map.mapMode' */
export const STATIONS = "STATIONS";
export const WIND_ROSES = "WIND_ROSES";
export const PM_BY_WIND = "PM_BY_WIND";
export const WEATHER = "WEATHER";